// extracted by mini-css-extract-plugin
var _1 = "landing-for-owners";
var _2 = "for-owners";
var _3 = "uploads/landing-for-owners";
export { _1 as "appFolder", _2 as "appId", _3 as "uploadsFolder" }
